import count from '~/assets/icons/count.svg';
import { CollectionImage } from '~/components/collections';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import {
	StyledBottomContainer,
	StyledCategory,
	StyledContainer,
	StyledCountContainer,
	StyledDisabledText,
	StyledImageContainer,
	StyledInfoContainer,
	StyledTimeContainer,
	StyledTitle,
} from './CraftItem.styled';

interface ICraftItemProps {
	itemId: string;
	title: string;
	category: string;
	active: boolean;
	disabled?: boolean;
	disabledText?: string;
	handleClick: () => void;
}

const CraftItem = ({
	itemId,
	title,
	category,
	active,
	disabled,
	disabledText,
	handleClick,
	...props
}: ICraftItemProps & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<StyledContainer $active={active} onClick={handleClick} {...props}>
			<StyledImageContainer>
				<CollectionImage collection={'items'} id={itemId} size={'md'} />
			</StyledImageContainer>
			<Divider $direction="V" $transition style={{ opacity: 0.1 }} />
			<StyledInfoContainer>
				<div>
					<StyledCategory>{category}</StyledCategory>
					<StyledTitle>{title}</StyledTitle>
					{disabled ? (
						<StyledDisabledText>{disabledText}</StyledDisabledText>
					) : (
						<StyledBottomContainer>
							<StyledCountContainer>
								<img src={count} />
								<Text>
									100 <span>шт.</span>
								</Text>
							</StyledCountContainer>
							<StyledTimeContainer>
								<div className="clock" />
								<Text>20 мин.</Text>
							</StyledTimeContainer>
						</StyledBottomContainer>
					)}
				</div>
			</StyledInfoContainer>
		</StyledContainer>
	);
};

export { CraftItem };
